import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import * as React from 'react';

import { withSpacingStyles } from '../withSpacingStyles';
import { Icon, useComponentTheme } from '..';

type Props = {
  className?: Node,
  color?: string,
  position?: string,
  dataTest?: string,
  top?: string,
};

export const Loader = withSpacingStyles(({ className, color, position, dataTest, top }: Props) => {
  const theme = useTheme();
  const componentTheme = useComponentTheme(theme => theme.components.Loader, 'default');

  return (
    <Wrapper className={className} position={position} data-test={dataTest} top={top}>
      {componentTheme.svg ? (
        <Img data={componentTheme.svg} />
      ) : (
        <Icon name="Loader" fill={color || componentTheme.color || theme.color.brand} size={100} spin />
      )}
    </Wrapper>
  );
});

const Wrapper = styled('div')`
  position: ${({ position }) => position};
  top: ${({ top }) => top};
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  max-width: 100px;
  max-height: 100px;
`;

const Img = styled('object')`
  max-width: 100px;
  max-height: 100px;
`;

Loader.defaultProps = {
  position: 'absolute',
  top: '40%'
};

Loader.displayName = 'Loader';
